import script from "./GridDocumentLinii.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridDocumentLinii.vue?vue&type=script&setup=true&lang=ts"

import "./GridDocumentLinii.vue?vue&type=style&index=0&id=63bc0a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63bc0a96"]])

export default __exports__